import { useCallback } from 'react';
import { FormikValues } from 'formik';
import { useAlert, useNavigate, handleMutation } from '@gv/triage-components';

import { useAppSelector } from 'store';
import { useHospitalParams } from 'hooks';
import {
  selectClient,
  useDetailsQuery,
  useUpdatePetMutation,
} from 'store/api/clients';

import { PetForm } from './form';
import { PetFormPage } from './types';
import { getInitialValues, getUpdatePayload } from './config';

const PetEditGlobal = ({
  clientId,
  isCasePage = false,
}: PetFormPage): JSX.Element => {
  const navigate = useNavigate();
  const { petId } = useHospitalParams();
  const [update, mutation] = useUpdatePetMutation();
  const { showErrorAlert } = useAlert();
  const { isFetching } = useDetailsQuery({ id: clientId! });
  const data = useAppSelector(selectClient(clientId));

  const onSuccess = useCallback(() => {
    if (isCasePage) {
      localStorage.setItem('comingBackFromPetEdit', 'true');
    }
    navigate(-1);
  }, []);
  handleMutation({ ...mutation, onSuccess });

  const onSubmit = async (values: FormikValues) => {
    if (clientId && petId) {
      const dataRes: any = await update(
        getUpdatePayload({
          petId,
          values,
          clientId,
        })
      );
      if (
        dataRes?.data?.dataValues?.message_alert &&
        dataRes?.data?.dataValues?.message_alert !== ''
      ) {
        showErrorAlert(dataRes?.data?.dataValues?.message_alert);
      }
    }
  };

  return (
    <PetForm
      isEdit
      isCasePage={true}
      onSubmit={onSubmit}
      isFetching={isFetching}
      initialValues={getInitialValues(data?.pets || [], petId)}
    />
  );
};

const PetEdit = (): JSX.Element => {
  const { clientId } = useHospitalParams();
  return <PetEditGlobal clientId={clientId!} />;
};

export { PetEdit, PetEditGlobal };
